import { businessKey } from 'queryKeys';

const REWARDS_PACKAGES = 'rewardPackages';
const rewardPackagesCampaignsQuery = businessKey.query(REWARDS_PACKAGES);

export const grid = rewardPackagesCampaignsQuery.grid();
